import { IOtherContact } from "@common/models/IOtherContact";

export const contactArrayFields = ['digitalChampion', 'cyberContact', 'esgContact', 'accountsReceivable', 'digitalPM', 'ITLT', 'procurement', 'hedging'];
export const contactSingleValueFields = ['ceo', 'cto', 'cfo'];

/**
 * Mapping from SharePoint role names to IOtherContact field names
 */
export const ROLE_TO_FIELD_MAP: Record<string, keyof IOtherContact> = {
    'Digital Champion': 'digitalChampion',
    'Cyber Contact': 'cyberContact',
    'ESG Contact': 'esgContact',
    'Billing Contact': 'accountsReceivable',
    'CEO': 'ceo',
    'CFO': 'cfo',
    'CTO': 'cto',
};

export const FIELD_TO_ROLE_MAP = Object.fromEntries(
  Object.entries(ROLE_TO_FIELD_MAP).map(([k, v]) => [v, k])
);

export const ROLES_KEY_NAME: any = {
    ceo: 'ceo',
    cto: 'cto',
    cfo: 'cfo',
    boardMembers: 'boardMembers',
    executionTeam: 'executionTeam',
    investmentCommittee: 'investmentCommittee',
    oversightPartners: 'oversightPartners',
    technicalAdvisors: 'technicalAdvisors', 
    digitalChampion: 'digitalChampion',
    ITLT: 'ITLT', 
    digitalPM: 'digitalPM', 
    esgContact: 'esgContact',
    cyberContact: 'cyberContact',
    accountsReceivable: 'accountsReceivable',
    procurement: 'procurement', 
    hedging: 'hedging'
}

export const PORTFOLIO_CONTACT_KEY_MAP: any = {
  lastName: 'Title', // Title appears to be used as last name
  firstName: 'FirstName',
  name: 'FullName',
  email: 'Email',
  company: 'Company',
  jobTitle: 'JobTitle',
  businessPhone: 'WorkPhone',
  mobilePhone: 'CellPhone',
  street: 'WorkAddress',
  city: 'WorkCity',
  state: 'WorkState',
  country: 'WorkCountry',
  zip: 'WorkZip',
  notes: 'Comments',
  roles: 'Roles'  // Type Array eg. [ "Cyber Contact"]
};


export const PORTFOLIO_COMPANY_CONTACT_KEY_MAP: any = {
  boardMembers: "BoardMembers", // Type Array eg. [{ "LookupId": 1, "LookupValue": "", "Email": ""}]
  executionTeam: "ExecutionTeam", // Type Array
  technicalAdvisors: "Technical", // Type Array
  oversightPartners: "OversightPartner", // Type Array
  investmentCommitteeApprovers: "InvestmentCommitteeChair", // Type Array
  digitalChampion: "DigitalChampion", // Type Array
  cyberContact: "CyberContact", // Type Array
  accountsReceivable: "AccountsReceivable", // Type String eg. abc@xyz.com;example@rew.com
  procurement: "Procurement", // Type String
  hedging: "Hedging", // Type String
  digitalPM: "DigitalPM",
  ITLT: "ITLT",
  ceo: "CEO",
  cto: "CTO",
  cfo: "CFO"
};


export const CONTACT_INTERNAL_FIELD_TYPE_STRING = [
  ROLES_KEY_NAME.procurement,
  ROLES_KEY_NAME.hedging
]
